import Vue from 'vue'
import VueTelInput from 'vue-tel-input'
import VueSocketIO from 'vue-socket.io'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

Vue.use(VueTelInput)

Vue.use(new VueSocketIO({
  // connection: 'http://localhost:5000',
  connection: location.origin,
  vuex: {
    store,
    actionPrefix: 'SOCKET_',
    mutationPrefix: 'SOCKET_'
  }
}))

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
